import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CitySelectionService } from '../../services/city-selection.service';
@Component({
    selector: 'app-full-calendar',
    templateUrl: './full-calendar.component.html',
    styleUrls: ['./full-calendar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FullCalendarComponent {
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate = new Date();
  today=new Date();
  @Input() dateType: 'travel' | 'return' = 'travel';

 
  constructor(
    private router: Router,
    private citySelection: CitySelectionService,
    private route: ActivatedRoute
    ) {
      this.dateType = this.route.snapshot.paramMap.get('dateType') as 'travel' | 'return';
  }

  onDateChange(value: string): void {
    const selectedDate = new Date(`${value}T00:00:00`);
    if (Number.isNaN(selectedDate.getTime())) return;
    if (this.dateType === 'travel') {
        this.citySelection.setTravelDate(selectedDate);
    } else if (this.dateType === 'return') {
        this.citySelection.setReturnDate(selectedDate);
    }

    this.router.navigate(['/']);
}
}
